import { useCallback, useEffect, useState } from "react";
import api from "./api";

/**
 * Global "categories changed" broadcaster. Any component that changes categories
 * (CategoryManagerDialog) calls broadcastCategoriesChanged() so listening
 * components refetch.
 */
const listeners = new Set();
export function broadcastCategoriesChanged() {
  listeners.forEach((l) => {
    try {
      l();
    } catch (e) {
      /* ignore */
    }
  });
}

/**
 * useCategories — fetch + subscribe to user's category catalog.
 * Returns { categories, loading, byKey, refresh }
 */
export function useCategories() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/finance/categories");
      setCategories(data || []);
    } catch (err) {
      setCategories([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
    listeners.add(load);
    return () => listeners.delete(load);
  }, [load]);

  const byKey = Object.fromEntries((categories || []).map((c) => [c.key, c]));

  return { categories, loading, byKey, refresh: load };
}
